import * as React from "react";
import { cn } from "../../lib/utils";

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-xl border bg-card text-card-foreground shadow-sm",
      "h-full transform transition-all duration-200 ease-in-out",
      "hover:scale-110 hover:bg-purple-500",
      className
    )}
    {...props}
  />
));
Card.displayName = "Card";

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div 
    ref={ref} 
    className={cn(
      "p-3 md:p-5",
      className
    )} 
    {...props} 
  />
));
CardContent.displayName = "CardContent";

export { Card, CardContent };